import { loadScript, common, Env } from '@mtfe/sweet-utils';

const { genGuid } = common;

const OPTIMUS_RISK_LEVEL = 71; // 71 代表滑块验证
const OPTIMUS_CODE = 10; // 10 代表数据请求

const yodaRootId = 'mtsi_yoda_root';
const yodaMaskRootId = 'mtsi_yoda_root_mask';

const _getMtsiUuid = () => {
    let uid = window.sessionStorage.getItem('MTSI_OPTIMUS_UUID');
    if (!uid) {
        uid = genGuid();
        window.sessionStorage.setItem('MTSI_OPTIMUS_UUID', uid);
    }
    return uid;
}

function creatYodaDom() {
    const yodaWrapper = document.createDocumentFragment('div');
    const yodaDom = document.createElement('div');
    const yodaDomMask = document.createElement('div');

    yodaWrapper.appendChild(yodaDom)
    yodaWrapper.appendChild(yodaDomMask)

    yodaDom.setAttribute('id', yodaRootId);
    yodaDom.setAttribute('style', 'z-index: 15;position: fixed;top: 0;left: 0;width: 100%;height: 100%;background-color: rgba(0,0,0,0.5);display: none;')
    yodaDomMask.setAttribute('id', yodaMaskRootId);

    document.body.appendChild(yodaWrapper);
}

// 滑块是否显示，避免多个接口命中，显示多次
let yodaIsShow = false;

// 滑块验证拦截
function startYoda(requestCode) {
    if (yodaIsShow) {
        return
    }

    yodaIsShow = true;

    const elem = document.getElementById(yodaRootId);
    if (elem) {
        elem.style.display = 'block';
    }

    window.mtsiYodaSuccessCallabck = function () {
        console.log('callbakc')
        window.location.reload();
    };

    window.mtsiYodaFailCallabck = function () {

    };

    const options = {
        requestCode: requestCode, //必须 授权码
        succCallbackFun: 'mtsiYodaSuccessCallabck', //必须 成功回调函数名 字符串格式
        failCallbackFun: 'mtsiYodaFailCallabck', //必须 失败回调函数名 字符串格式
        root: yodaRootId, //必须 挂载业务方页面节点id
    };

    const curEnv = Env.getCurEnvFromHost();

    if (curEnv === 'prod') {
        window.YodaSeed(options);
    } else {
        window.YodaSeed(options, curEnv); //线下 dev|test|ppe|staging
    }
}

// 需要走mtsi校验的接口，添加optimus_uuid、optimus_risk_level、optimus_code三个参数
function setMTSIParams(data) {
    Object.assign(data, {
        optimus_uuid: _getMtsiUuid(),
        optimus_risk_level: OPTIMUS_RISK_LEVEL,
        optimus_code: OPTIMUS_CODE,
    });
}

/** 
 * requestCode：授权码
 * 使用滑块验证
*/
function useYodaInterceptor(requestCode) {
    if (!window.YodaSeed) {
        loadScript('//s0.meituan.net/mxx/yoda/yoda.seed.js', {}, function (err, script) {
            console.log('加载yoda：', err)
            if (!err) {
                creatYodaDom();
                startYoda(requestCode);
            } else {
                throw new Error('滑块验证脚本加载失败!');
            }
        });
    } else {
        startYoda(requestCode);
    }
}

export {
    setMTSIParams,
    useYodaInterceptor
}
